<template>
  <div class="mymap" :style="{'height':height + 'px'}">
    <g-map-map @="saveMap" :center="center" :zoom.sync="zoom" :editable="true" class="chartmap" map-type-id="terrain" @zoom_changed="zoomChange">
      <!-- @mouseover="m.position.showInfo=true" @mouseout="m.position.showInfo=false" -->
      <g-map-marker v-for="(m, index) in markers" :key="index" :position="m.position" :clickable="true" @click="sendQueryRowSelEvent(m)" :animation="animMarkerIdx==index?1:0"/>

      <g-map-polyline v-if="this.polypath.length>0" :path="polypath" :clickable="true" @click="m.position.showInfo=true" deepWatch
                      :options="{ strokeColor: '#00AFE9', strokeOpacity: 1.0, strokeWeight: 4,
                     icons: [{ icon: { path: 'M -13.039061,23.617919 0.49203953,-14.023142 13.285082,23.125879 0.73805853,14.02314 Z',
                     scale: 0.6, fillOpacity: 0.8, fillColor: '#003366' }, offset: '0', repeat: '40px' }] }"/>

      <g-map-info-window v-for="(m, index) in markers.filter(ma => ma.position.showInfo)" :position="getInfoWindowPosition(m)" :key="index + m.position.title" :options="{ disableAutoPan: true }"
                         :closeclick="true" @closeclick="m.position.showInfo=false">
        <span style="color:black" v-html="m.position.title"/>
      </g-map-info-window>
    </g-map-map>
  </div>
</template>

<script>
export default {
  name: 'GoogleMaps',
  props: ['height', 'chartType', 'queryColumns', 'queryResult'],
  components: {},

  data() {
    return {
      map: null,
      markers: [],
      polypath: [],
      center: {lat: 48.204540, lng: 15.622660},
      // testcenter: {lat: 1.38, lng: 103.8},
      zoom: 10,
      showInfo: false,
      animMarkerIdx: null
    }
  },

  watch: {
    queryResult() {
      this.init()
    }
  },

  methods: {
    saveMap(map) {
      this.map = map
      this.map.setOptions({disableDefaultUI: false});
      console.log("savemap !!!!!!!!!!!!!!!!!!!")
    },
    init() {
      if (this.queryResult && this.queryResult.length > 0) {
        for (let idx = 0; idx < this.queryResult.length; idx++) {
          let row = this.queryResult[idx]

          //console.warn("PATH:", google.maps.SymbolPath.FORWARD_CLOSED_ARROW)

          if (row.POI_LAT && row.POI_LNG) {
            //console.log("push: ", row)
            this.markers.push({position: {"lat": parseFloat(row.POI_LAT), "lng": parseFloat(row.POI_LNG), "title": row.POI_TITLE, "time": row.POI_TIME, "showInfo": false}})

            if (row.MAP_TYPE && row.MAP_TYPE.includes("L")) {
              this.polypath.push({"lat": parseFloat(row.POI_LAT), "lng": parseFloat(row.POI_LNG)})
            }

            if (idx == 0) {
              if (row.CENT_LAT) this.center.lat = parseFloat(row.CENT_LAT)
              if (row.CENT_LNG) this.center.lng = parseFloat(row.CENT_LNG)
              if (row.MAP_ZOOM) this.zoom = parseFloat(row.MAP_ZOOM)
            }
          }
        }

        if (this.markers.length == 0) {
          this.$q.dialog({
            title: "Keine POIs vorhanden",
            message: "Die Abfrage lieferte keine Daten zur Anzeigen von POIs."
          })
        }
      }
    },
    zoomChange(zoom) {
      this.zoom = zoom
    },
    getInfoWindowPosition(marker) {
      let latOffset = 0.04
      switch (this.zoom) {
        case 1:
          latOffset = 17;
          break
        case 2:
          latOffset = 9;
          break
        case 3:
          latOffset = 4.8;
          break
        case 4:
          latOffset = 2.5;
          break
        case 5:
          latOffset = 1.2;
          break
        case 6:
          latOffset = 0.6;
          break
        case 7:
          latOffset = 0.3;
          break
        case 8:
          latOffset = 0.15;
          break
        case 9:
          latOffset = 0.08;
          break
        case 11:
          latOffset = 0.02;
          break
        case 12:
          latOffset = 0.01;
          break
        case 13:
          latOffset = 0.005;
          break
        case 14:
          latOffset = 0.0025;
          break
        case 15:
          latOffset = 0.0011;
          break
        case 16:
          latOffset = 0.0006;
          break
        case 17:
          latOffset = 0.0003;
          break
        case 18:
          latOffset = 0.00018;
          break
        case 19:
          latOffset = 0.0001;
          break
        case 20:
          latOffset = 0.00004;
          break
        case 21:
          latOffset = 0.00002;
          break
      }
      //console.log("offset for zoom :", this.zoom, " is: ", latOffset)
      return {lat: marker.position.lat + latOffset, lng: marker.position.lng}
    },

    sendQueryRowSelEvent(marker) {
      this.showMarkerInfo(marker)
      for (let i = 0; i < this.queryColumns.length; i++) {
        if (this.queryColumns[i].nullValueReplacement && this.queryColumns[i].nullValueReplacement.includes("::EVENT_TRIGGER")) {
          //console.log("emit event", marker.position.time)
          this.eventBus.queryRowSel(this.queryID, this.queryColumns[i], marker.position.time)
          break
        }
      }
    },

    queryRowSelEventReceiver({senderQueryID, col, value}) {
      //console.log("GMAP - queryRowSelEventReceiver.", col, value)

      for (let i = 0; i < this.queryColumns.length; i++) {
        if (this.queryColumns[i].nullValueReplacement && this.queryColumns[i].nullValueReplacement.includes("::EVENT_RECEIVER")) {
          //console.log("found receiver col:", this.queryColumns[i].nullValueReplacement, "==", this.columns[i].label, ", value:", value)
          //console.log("queryResult:", this.queryResult)
          for (let r = 0; r < this.queryResult.length; r++) {
            if (Object.values(this.queryResult[r])[i] == value) {
              this.animMarkerIdx = r
              this.showMarkerInfo(this.markers[r])
              this.zoom = 11
              this.center = {lat: parseFloat(this.queryResult[r].POI_LAT), lng: parseFloat(this.queryResult[r].POI_LNG)}
              //console.log("Animated Marker Idx:", this.queryResult[r], this.queryResult[r].POI_LAT, this.queryResult[r].POI_LNG)
              break
            }
          }
          break
        }
      }
    },

    showMarkerInfo(marker) {
      this.markers.forEach((marker) => {
        marker.position.showInfo = false
      })
      marker.position.showInfo = true
    }
  },

  beforeUnmount: function () {
    this.eventBus.off("onQueryRowSel", this.queryRowSelEventReceiver)
  },

  mounted: function () {
    this.eventBus.on("onQueryRowSel", this.queryRowSelEventReceiver)
    this.init()
  }
}

</script>

<style lang="sass">
.chartmap
  height: 100%
</style>
